import { ArrowBackIcon } from "@chakra-ui/icons";
import { Box, Button, Heading, HStack, Spinner } from "@chakra-ui/react";
import GenericForm from "components/BuilderForm/GenericForm";
import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import useApi from "hooks/useApi";
import toast from "react-hot-toast";
import { createPlan, getFormData } from "./apiService";
import { useQueryParams } from "utils/common";

const CreatePlan = () => {
  const { propertyId, is_custom } = useQueryParams();
  const isCustomPlan = is_custom === "1";

  const initialFormData = {
    name: "",
    description: "",
    type: "",
    user_type: "",
    category: "",
    features: [],
    pricing: {},
  }; // Set initial form type to 'plan'
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const { apiCall, loading } = useApi();
  const history = useHistory();

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = ({ updatedFormData }) => {
    const { features, ...restOfTheForm } = updatedFormData;
    const updatedFeatures = features.map((feature) => {
      const { value_template, ...rest } = feature;
      return rest;
    });

    let { user_id, valid_till, ...others } = restOfTheForm;

    const planData = {
      ...others,
      ...(user_id && { user_id }),
      ...(valid_till && { valid_till }),
    };


    const payload = { features: updatedFeatures, ...planData };
    const newErrors = {};

    // Implement your validation logic here
    // Example validation logic
    if (!payload.name) {
      newErrors.name = "Name is required.";
    }
    if (is_custom) {
      if(!payload.user_id) newErrors.user_id = "Please select a user";
      if(!payload.valid_till) newErrors.valid_till = "Please enter the validity of custom plan";
    }

    return { newErrors, payload };
  };

  const getFormDataFn = async () => {
    try {
      const response = await getFormData({ apiCall, propertyId });
      setFormData({ ...response });
    } catch (error) {
      console.log("Error fetching property data", error);
    }
  };

  useEffect(() => {
    if (propertyId) {
      getFormDataFn();
    }
  }, [propertyId]);

  const handleFormSubmit = async () => {
    try {
      const { newErrors, payload } = validateForm({
        updatedFormData: formData,
      });
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        toast.error("Please correct the errors in the form.");
        return;
      }
      const modifiedPayload = { ...payload };

      if (isCustomPlan) {
        modifiedPayload.is_custom = true;
      } else if (payload._id) {
        modifiedPayload.plan_id = payload?._id;
      }
      delete modifiedPayload?._id;
      delete modifiedPayload?.status;
      delete modifiedPayload?.uid;
      const response = await createPlan({ apiCall, payload: modifiedPayload });
      if (response) {
        setFormData(initialFormData);
        history.push("/admin/plans");
      }
    } catch (error) {
      console.error("Error submitting plan:", error);
      toast.error(
        error.message || "An error occurred while submitting the plan."
      );
    }
  };

  const heading = useMemo(() => {
    if (isCustomPlan) return `Create Custom ${formData.name} Plan`;
    if (propertyId) return `Update ${formData.name} Plan`;
    return "Create Plan";
  }, [formData, propertyId, isCustomPlan]);

  return (
    <Box
      p={4}
      px={{ base: 4, md: 8 }}
      maxW={{ base: "100%", md: "1100px" }}
      mx="auto"
    >
      <Box onClick={() => history.goBack()} style={{ cursor: "pointer" }}
        position={{ base: 'fixed', md: 'relative'}} zIndex={100000}     bgColor={'white'} rounded={'full'} py={3} px={4} top={2} left={2} w={'fit-content'}>
        <ArrowBackIcon height={{ base: 4, md:8}} width={{ base: 4, md:8}} />
      </Box>
      {loading && <Spinner size="lg" />}
      <Box textAlign="center" mb={6}>
        <Heading>{heading}</Heading>
      </Box>
      <GenericForm
        formType="plan"
        formData={{ ...formData, is_custom: isCustomPlan }}
        onChange={handleFormChange}
        errors={errors}
        setErrors={setErrors}
      />
      <HStack mt={4} justifyContent="center" alignItems="center" spacing={4}>
        <Button
          colorScheme="teal"
          size="lg"
          px={8}
          py={6}
          fontSize="lg"
          bg="purple.500"
          borderRadius="5px"
          borderColor="#637381"
          background={"linear-gradient(180deg, #22ACEE 0%, #0177B4 100%)"}
          color="#ffffff"
          onClick={handleFormSubmit}
          disabled={loading}
        >
          Submit
        </Button>
      </HStack>
    </Box>
  );
};

export default CreatePlan;
